import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import tokens from '../../design/tokens'
import colors from '../../design/color-names'

export const PANEL_SPACING_VARIANT_PRIMARY = 'primary'
export const PANEL_SPACING_VARIANT_SECONDARY = 'secondary'

const StyledPanel = styled.div`
  label: e-panel;
  background-color: ${colors.pureWhite};
  border: 1px solid ${colors.geyser};
  border-radius: ${tokens.borderRadius.medium};
  margin: ${props => props.$margin};
  padding: ${tokens.spacing.large} ${tokens.spacing.xLarge};
  padding: ${props =>
    props.spacingVariant === PANEL_SPACING_VARIANT_PRIMARY
      ? `${tokens.spacing.large} ${tokens.spacing.xLarge}`
      : null};
  padding: ${props =>
    props.spacingVariant === PANEL_SPACING_VARIANT_SECONDARY
      ? `${tokens.spacing.medium} ${tokens.spacing.xLarge}`
      : null};
  opacity: ${props => (props.disabled ? '0.6' : null)};
  ${props => (props.$height ? `height: ${props.$height};` : null)}
  * {
    cursor: ${props => (props.disabled ? 'default' : null)};
  }
`

export const Panel = ({
  children,
  className,
  spacingVariant,
  onClick,
  disabled,
  'data-mu-test': dataAttributeTest,
  margin,
  height
}) => {
  /*  CASO NO CHILDREN?
  {children && (
    <StyledCollapsible
      data-mu-test={dataAttributeTest && `${dataAttributeTest}-children`}
      collapsed={!checked}
    >
      {children}
    </StyledCollapsible>
  )} */
  return (
    <StyledPanel
      className={className}
      data-mu-test={dataAttributeTest}
      onClick={onClick}
      spacingVariant={spacingVariant}
      disabled={disabled}
      $margin={margin}
      $height={height}
    >
      {children}
    </StyledPanel>
  )
}

Panel.defaultProps = {
  spacing: PANEL_SPACING_VARIANT_PRIMARY,
  margin: `0 0 ${tokens.spacing.large} 0`
}

Panel.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  spacingVariant: PropTypes.oneOf([
    PANEL_SPACING_VARIANT_PRIMARY,
    PANEL_SPACING_VARIANT_SECONDARY
  ]),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  'data-mu-test': PropTypes.string,
  margin: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.string
}
